import { useEffect, useState } from "react";
import api, { API } from "@/lib/api";
import { UploadSimple, FileText } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function Documents() {
  const [docs, setDocs] = useState([]);
  const load = () => api.get("/documents").then(r => setDocs(r.data));
  useEffect(() => { load(); }, []);

  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    await api.post("/upload", fd);
    toast.success("Uploaded");
    load();
  };

  return (
    <div data-testid="documents-page" className="space-y-6">
      <header className="flex justify-between items-end">
        <div>
          <div className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">Documents</div>
          <h1 className="text-3xl md:text-4xl font-semibold tracking-tight">Supporting files</h1>
        </div>
        <label className="inline-flex items-center gap-2 al-gradient text-white px-5 py-3 rounded-full font-medium cursor-pointer active:scale-95 transition-transform">
          <UploadSimple size={16}/> Upload
          <input data-testid="docs-upload" type="file" className="hidden" onChange={upload}/>
        </label>
      </header>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {docs.length === 0 && <div className="text-slate-400 text-sm">No documents yet.</div>}
        {docs.map(d => (
          <a key={d.id} data-testid={`doc-${d.id}`} href={`${API}/files/${d.id}`} target="_blank" rel="noreferrer" className="card-hover bg-white rounded-2xl border border-slate-200/70 p-5 flex gap-3 items-start">
            <div className="w-10 h-10 rounded-xl bg-slate-100 flex items-center justify-center"><FileText size={20} className="text-slate-500"/></div>
            <div className="min-w-0">
              <div className="font-medium truncate">{d.filename}</div>
              <div className="text-xs text-slate-500">{Math.round((d.size||0)/1024)} KB · {new Date(d.created_at).toLocaleDateString()}</div>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}
